if (!customElements.get("splide-slider")) {
  customElements.define(
    "splide-slider",
    class SplideSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.splide')
      }
      connectedCallback() {
        if (typeof window.Splide === "undefined" || !this.slider) return;
        const splide = new window.Splide(this.slider);
        splide.mount();
      }
    }
  );
}
